import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API, useAuth } from '../contexts/AuthContext';
import { playNotificationSound } from '../helpers/notificationSound';

const DIAS = [
  { num: 0, label: 'Dom' },
  { num: 1, label: 'Seg' },
  { num: 2, label: 'Ter' },
  { num: 3, label: 'Qua' },
  { num: 4, label: 'Qui' },
  { num: 5, label: 'Sex' },
  { num: 6, label: 'Sab' },
];

const PRIORIDADES = [
  { chave: 'baixa', label: 'Baixa' },
  { chave: 'media', label: 'Media' },
  { chave: 'alta', label: 'Alta' },
  { chave: 'urgente', label: 'Urgente' },
];

const SONS_NOVA_MENSAGEM = [
  { chave: 'suave', label: 'Suave' },
  { chave: 'alerta', label: 'Alerta' },
  { chave: 'discreto', label: 'Discreto' },
];

const PLACEHOLDERS = {
  mensagem_saudacao: 'Oi! Sou o assistente da TI do Centrao. Vou abrir um chamado para voce.',
  mensagem_fora_horario: 'Oi! No momento estamos fora do horario de atendimento. Sua mensagem foi recebida - retornaremos no proximo horario util.',
  mensagem_cancelamento: 'Tudo bem, descartei o registro. Quando precisar de novo, e so mandar uma mensagem.',
  mensagem_chamado_criado: 'Pronto! Seu chamado foi registrado com o numero *#{{numero}}*. Um atendente vai analisar em breve.',
};

function minutosParaTexto(min) {
  if (!min || min < 1) return '';
  if (min < 60) return `= ${min} min`;
  if (min < 1440) return `= ${(min / 60).toFixed(min % 60 === 0 ? 0 : 1)}h`;
  return `= ${(min / 1440).toFixed(min % 1440 === 0 ? 0 : 1)} dias`;
}

export default function AdminAtendimento() {
  const { temPermissao } = useAuth();
  const podeEditar = temPermissao('admin:atendimento');

  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [motivos, setMotivos] = useState([]);
  const [motivosErro, setMotivosErro] = useState('');
  const [modoModal, setModoModal] = useState({ aberto: false, editando: null });
  const [modoNome, setModoNome] = useState('');
  const [modoMensagem, setModoMensagem] = useState('');
  const [modoSalvando, setModoSalvando] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [categoriasErro, setCategoriasErro] = useState('');
  const [filiais, setFiliais] = useState([]);
  const [filiaisErro, setFiliaisErro] = useState('');
  const [setores, setSetores] = useState([]);
  const [setoresErro, setSetoresErro] = useState('');
  // Respostas rapidas: cadastro CRUD e simples (atalho + texto). Reusa o mesmo
  // padrao de modal do resto da tela.
  const [respostas, setRespostas] = useState([]);
  const [respostasErro, setRespostasErro] = useState('');
  const [rrModal, setRrModal] = useState({ aberto: false, editando: null });
  const [rrAtalho, setRrAtalho] = useState('');
  const [rrTexto, setRrTexto] = useState('');
  const [rrSalvando, setRrSalvando] = useState(false);

  useEffect(() => {
    if (!podeEditar) {
      setLoading(false);
      return;
    }
    // Cargas independentes - uma falhar nao deve esconder a outra
    Promise.allSettled([
      axios.get(`${API}/atendimento/config`),
      axios.get(`${API}/atendimento/motivos`),
      axios.get(`${API}/atendimento/categorias`),
      axios.get(`${API}/atendimento/filiais`),
      axios.get(`${API}/atendimento/setores`),
      axios.get(`${API}/atendimento/respostas-rapidas`),
    ])
      .then(([resConfig, resMotivos, resCategorias, resFiliais, resSetores, resRespostas]) => {
        if (resRespostas?.status === 'fulfilled') {
          setRespostas(resRespostas.value.data?.data || []);
          setRespostasErro('');
        } else if (resRespostas) {
          const msg = resRespostas.reason?.response?.data?.message || resRespostas.reason?.message || '';
          if (/Invalid object name|siti_resposta_rapida/i.test(msg)) {
            setRespostasErro('Tabela de respostas rapidas nao existe. Aplique a migration 062_respostas_rapidas.sql.');
          } else {
            setRespostasErro('Nao foi possivel carregar as respostas rapidas.');
          }
        }
        if (resConfig.status === 'fulfilled') {
          setConfig(resConfig.value.data?.data || null);
        } else {
          setErro('Nao foi possivel carregar a configuracao.');
        }
        if (resMotivos.status === 'fulfilled') {
          setMotivos(resMotivos.value.data?.data || []);
          setMotivosErro('');
        } else {
          const msg = resMotivos.reason?.response?.data?.message || resMotivos.reason?.message || '';
          // Quando a tabela ainda nao existe, o SQL Server retorna "Invalid object name".
          if (/Invalid object name|siti_atendimento_motivo/i.test(msg)) {
            setMotivosErro('Tabela de motivos nao existe. Aplique a migration 011_motivos_encerramento.sql na base.');
          } else {
            setMotivosErro('Nao foi possivel carregar os motivos de encerramento.');
          }
        }
        if (resCategorias.status === 'fulfilled') {
          setCategorias(resCategorias.value.data?.data || []);
          setCategoriasErro('');
        } else {
          const msg = resCategorias.reason?.response?.data?.message || resCategorias.reason?.message || '';
          if (/Invalid object name|siti_atendimento_categoria/i.test(msg)) {
            setCategoriasErro('Tabela de categorias nao existe. Aplique a migration 013_catalogos_atendimento.sql na base.');
          } else {
            setCategoriasErro('Nao foi possivel carregar as categorias.');
          }
        }
        if (resFiliais.status === 'fulfilled') {
          setFiliais(resFiliais.value.data?.data || []);
          setFiliaisErro('');
        } else {
          const msg = resFiliais.reason?.response?.data?.message || resFiliais.reason?.message || '';
          if (/Invalid object name|dbo\.FILIAIS/i.test(msg)) {
            setFiliaisErro('View dbo.FILIAIS nao encontrada em BDCENTRAO. Verifique se a view existe na base de dados.');
          } else {
            setFiliaisErro('Nao foi possivel carregar as filiais.');
          }
        }
        if (resSetores.status === 'fulfilled') {
          setSetores(resSetores.value.data?.data || []);
          setSetoresErro('');
        } else {
          const msg = resSetores.reason?.response?.data?.message || resSetores.reason?.message || '';
          if (/Invalid object name|siti_atendimento_setor/i.test(msg)) {
            setSetoresErro('Tabela de setores nao existe. Aplique a migration 014_filial_codigo_setor.sql na base.');
          } else {
            setSetoresErro('Nao foi possivel carregar os setores.');
          }
        }
      })
      .finally(() => setLoading(false));
  }, [podeEditar]);

  const recarregarMotivos = async () => {
    try {
      const res = await axios.get(`${API}/atendimento/motivos`);
      setMotivos(res.data?.data || []);
    } catch (e) { /* silencioso */ }
  };

  const recarregarCategorias = async () => {
    try {
      const res = await axios.get(`${API}/atendimento/categorias`);
      setCategorias(res.data?.data || []);
    } catch (e) { /* silencioso */ }
  };



  const recarregarSetores = async () => {
    try {
      const res = await axios.get(`${API}/atendimento/setores`);
      setSetores(res.data?.data || []);
    } catch (e) { /* silencioso */ }
  };

  const abrirNovoModo = () => {
    setModoNome('');
    setModoMensagem('');
    setModoModal({ aberto: true, editando: null });
  };

  const abrirEditarModo = (modo) => {
    setModoNome(modo.descricao || '');
    setModoMensagem(modo.mensagem_cliente || '');
    setModoModal({ aberto: true, editando: modo });
  };

  const fecharModoModal = () => setModoModal({ aberto: false, editando: null });

  const salvarModo = async () => {
    const nome = modoNome.trim();
    if (nome.length < 3) {
      Swal.fire({ icon: 'warning', title: 'Atencao', text: 'Nome precisa ter ao menos 3 caracteres.' });
      return;
    }
    setModoSalvando(true);
    try {
      const body = { descricao: nome, mensagem_cliente: modoMensagem.trim() || null };
      if (modoModal.editando) {
        await axios.put(`${API}/atendimento/motivos/${modoModal.editando.id}`, body);
      } else {
        await axios.post(`${API}/atendimento/motivos`, { ...body, ordem: (motivos.length + 1) * 10 });
      }
      await recarregarMotivos();
      fecharModoModal();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    } finally {
      setModoSalvando(false);
    }
  };

  const toggleAtivoMotivo = async (motivo) => {
    try {
      await axios.put(`${API}/atendimento/motivos/${motivo.id}`, { ativo: !motivo.ativo });
      await recarregarMotivos();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const removerMotivo = async (motivo) => {
    const r = await Swal.fire({
      icon: 'warning',
      title: 'Remover motivo?',
      text: `"${motivo.descricao}" sera apagado. Chamados ja fechados que usaram esse motivo continuam com o registro.`,
      showCancelButton: true,
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#b43737',
    });
    if (!r.isConfirmed) return;
    try {
      await axios.delete(`${API}/atendimento/motivos/${motivo.id}`);
      await recarregarMotivos();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const novaCategoria = async () => {
    const { value: nome } = await Swal.fire({
      title: 'Nova categoria',
      input: 'text',
      inputLabel: 'Nome exibido para o usuario',
      inputPlaceholder: 'Ex: Telefonia',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Adicionar',
      cancelButtonText: 'Cancelar',
      inputValidator: (v) => (!v || v.trim().length < 2) && 'Minimo 2 caracteres.',
    });
    if (!nome) return;
    try {
      await axios.post(`${API}/atendimento/categorias`, {
        nome: nome.trim(),
        ordem: (categorias.length + 1) * 10,
      });
      await recarregarCategorias();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const renomearCategoria = async (categoria) => {
    const { value: nome } = await Swal.fire({
      title: 'Editar categoria',
      input: 'text',
      inputValue: categoria.nome,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      inputValidator: (v) => (!v || v.trim().length < 2) && 'Minimo 2 caracteres.',
    });
    if (!nome || nome.trim() === categoria.nome) return;
    try {
      await axios.put(`${API}/atendimento/categorias/${categoria.id}`, { nome: nome.trim() });
      await recarregarCategorias();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const toggleAtivoCategoria = async (categoria) => {
    try {
      await axios.put(`${API}/atendimento/categorias/${categoria.id}`, { ativo: !categoria.ativo });
      await recarregarCategorias();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const removerCategoria = async (categoria) => {
    const r = await Swal.fire({
      icon: 'warning',
      title: 'Remover categoria?',
      text: `"${categoria.nome}" sera apagada do catalogo. Chamados antigos continuam com a chave gravada.`,
      showCancelButton: true,
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#b43737',
    });
    if (!r.isConfirmed) return;
    try {
      await axios.delete(`${API}/atendimento/categorias/${categoria.id}`);
      await recarregarCategorias();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const novoSetor = async () => {
    const { value: nome } = await Swal.fire({
      title: 'Novo setor',
      input: 'text',
      inputLabel: 'Nome do setor',
      inputPlaceholder: 'Ex: Compras',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Adicionar',
      cancelButtonText: 'Cancelar',
      inputValidator: (v) => (!v || v.trim().length < 2) && 'Minimo 2 caracteres.',
    });
    if (!nome) return;
    try {
      await axios.post(`${API}/atendimento/setores`, {
        nome: nome.trim(),
        ordem: (setores.length + 1) * 10,
      });
      await recarregarSetores();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const renomearSetor = async (setor) => {
    const { value: nome } = await Swal.fire({
      title: 'Editar setor',
      input: 'text',
      inputValue: setor.nome,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      inputValidator: (v) => (!v || v.trim().length < 2) && 'Minimo 2 caracteres.',
    });
    if (!nome || nome.trim() === setor.nome) return;
    try {
      await axios.put(`${API}/atendimento/setores/${setor.id}`, { nome: nome.trim() });
      await recarregarSetores();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const toggleAtivoSetor = async (setor) => {
    try {
      await axios.put(`${API}/atendimento/setores/${setor.id}`, { ativo: !setor.ativo });
      await recarregarSetores();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const removerSetor = async (setor) => {
    const r = await Swal.fire({
      icon: 'warning',
      title: 'Remover setor?',
      text: `"${setor.nome}" sera apagado do catalogo. Chamados antigos continuam com o setor gravado.`,
      showCancelButton: true,
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#b43737',
    });
    if (!r.isConfirmed) return;
    try {
      await axios.delete(`${API}/atendimento/setores/${setor.id}`);
      await recarregarSetores();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const setCampo = (campo, valor) => setConfig((prev) => ({ ...prev, [campo]: valor }));

  const atualizarHorario = (dia, campo, valor) => {
    setConfig((prev) => {
      const horarios = Array.isArray(prev.horarios) ? [...prev.horarios] : [];
      const idx = horarios.findIndex((h) => Number(h.dia_semana) === dia);
      if (idx === -1) {
        horarios.push({ dia_semana: dia, ativo: false, inicio: '08:00', fim: '18:00', [campo]: valor });
      } else {
        horarios[idx] = { ...horarios[idx], [campo]: valor };
      }
      horarios.sort((a, b) => Number(a.dia_semana) - Number(b.dia_semana));
      return { ...prev, horarios };
    });
  };

  // --- Respostas rapidas ---
  const recarregarRespostas = async () => {
    try {
      const res = await axios.get(`${API}/atendimento/respostas-rapidas`);
      setRespostas(res.data?.data || []);
    } catch (_) { /* silencia — banner ja mostra erro */ }
  };
  const abrirNovaRR = () => { setRrModal({ aberto: true, editando: null }); setRrAtalho(''); setRrTexto(''); };
  const abrirEditarRR = (r) => { setRrModal({ aberto: true, editando: r }); setRrAtalho(r.atalho); setRrTexto(r.texto); };
  const fecharRR = () => { setRrModal({ aberto: false, editando: null }); setRrAtalho(''); setRrTexto(''); };
  const salvarRR = async () => {
    setRrSalvando(true);
    try {
      const body = { atalho: rrAtalho.trim(), texto: rrTexto.trim() };
      if (rrModal.editando) {
        await axios.put(`${API}/atendimento/respostas-rapidas/${rrModal.editando.id}`, body);
      } else {
        await axios.post(`${API}/atendimento/respostas-rapidas`, body);
      }
      fecharRR();
      await recarregarRespostas();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    } finally {
      setRrSalvando(false);
    }
  };
  const toggleRR = async (r) => {
    try {
      await axios.put(`${API}/atendimento/respostas-rapidas/${r.id}`, { ativo: !r.ativo });
      await recarregarRespostas();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };
  const removerRR = async (r) => {
    const c = await Swal.fire({
      icon: 'warning', title: 'Remover resposta?', text: `/${r.atalho} sera apagada.`,
      showCancelButton: true, confirmButtonText: 'Remover', cancelButtonText: 'Cancelar',
      confirmButtonColor: '#b43737',
    });
    if (!c.isConfirmed) return;
    try {
      await axios.delete(`${API}/atendimento/respostas-rapidas/${r.id}`);
      await recarregarRespostas();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  const horariosOrdenados = (() => {
    const arr = Array.isArray(config?.horarios) ? config.horarios : [];
    // Garante 7 linhas mesmo que o backend retorne incompleto
    return DIAS.map((d) => arr.find((h) => Number(h.dia_semana) === d.num)
      || { dia_semana: d.num, ativo: false, inicio: '08:00', fim: '18:00' });
  })();

  const salvar = async () => {
    setSalvando(true);
    try {
      const res = await axios.put(`${API}/atendimento/config`, config);
      setConfig(res.data?.data || config);
      Swal.fire({
        icon: 'success',
        title: 'Salvo!',
        text: 'Configuracao do atendimento atualizada.',
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao salvar',
        text: err.response?.data?.message || err.message,
      });
    } finally {
      setSalvando(false);
    }
  };

  if (!podeEditar) {
    return (
      <div className="content-shell">
        <div className="feedback-banner feedback-banner--error">
          Voce nao tem permissao para configurar o atendimento.
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="content-shell">
        <div className="content-card content-card--centered">
          <div className="screen-loader__spinner" />
          <p>Carregando configuracao...</p>
        </div>
      </div>
    );
  }

  if (!config) {
    return (
      <div className="content-shell">
        <div className="feedback-banner feedback-banner--error">
          {erro || 'Configuracao nao encontrada.'}
        </div>
      </div>
    );
  }


  return (
    <div className="content-shell">
      <section className="page-header">
        <div>
          <span className="section-header__eyebrow">Administracao</span>
          <h1>Atendimento WhatsApp</h1>
          <p>Defina horario, mensagens automaticas do bot e SLA por prioridade.</p>
        </div>
      </section>

      {erro && <div className="feedback-banner feedback-banner--error">{erro}</div>}

      {/* Horario */}
      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <h4 style={{ color: 'var(--portal-text)', marginBottom: 12 }}>
          <i className="bi bi-clock me-2" /> Horario de atendimento
        </h4>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 16 }}>
          Quando ativo, mensagens recebidas fora do horario nao iniciam o bot - apenas
          enviam o aviso configurado abaixo. Conversas que ja estavam em andamento
          continuam normalmente.
        </p>

        <div className="form-check form-switch mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="horario-ativo"
            checked={Boolean(config.horario_ativo)}
            onChange={(e) => setCampo('horario_ativo', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="horario-ativo">
            Aplicar restricao de horario
          </label>
        </div>

        <div style={{ opacity: config.horario_ativo ? 1 : 0.55, pointerEvents: config.horario_ativo ? 'auto' : 'none' }}>
          <div className="table-shell">
            <table className="portal-table">
              <thead>
                <tr>
                  <th style={{ width: 80 }}>Dia</th>
                  <th style={{ width: 90 }}>Ativo</th>
                  <th>Inicio</th>
                  <th>Fim</th>
                </tr>
              </thead>
              <tbody>
                {horariosOrdenados.map((h, idx) => {
                  const dia = DIAS[idx];
                  return (
                    <tr key={dia.num} style={{ opacity: h.ativo ? 1 : 0.65 }}>
                      <td><strong>{dia.label}</strong></td>
                      <td>
                        <div className="form-check form-switch" style={{ marginBottom: 0 }}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={Boolean(h.ativo)}
                            onChange={(e) => atualizarHorario(dia.num, 'ativo', e.target.checked)}
                          />
                        </div>
                      </td>
                      <td>
                        <input
                          type="time"
                          className="form-control form-control-sm"
                          style={{ maxWidth: 140 }}
                          value={h.inicio || '08:00'}
                          onChange={(e) => atualizarHorario(dia.num, 'inicio', e.target.value)}
                          disabled={!h.ativo}
                        />
                      </td>
                      <td>
                        <input
                          type="time"
                          className="form-control form-control-sm"
                          style={{ maxWidth: 140 }}
                          value={h.fim || '18:00'}
                          onChange={(e) => atualizarHorario(dia.num, 'fim', e.target.value)}
                          disabled={!h.ativo}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: '0.78rem', color: 'var(--portal-muted)', marginTop: 8, marginBottom: 0 }}>
            Cada dia tem horario proprio - permite, por exemplo, Seg-Sex 08:00-18:00 e Sab 08:00-12:00.
          </p>
        </div>
      </section>

      {/* Mensagens */}
      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <h4 style={{ color: 'var(--portal-text)', marginBottom: 12 }}>
          <i className="bi bi-chat-text me-2" /> Mensagens automaticas
        </h4>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 16 }}>
          Deixe em branco para usar o texto padrao. A mensagem de chamado criado aceita
          o placeholder <code>{'{{numero}}'}</code> para o id do chamado.
        </p>

        {[
          { campo: 'mensagem_saudacao', label: 'Saudacao inicial' },
          { campo: 'mensagem_fora_horario', label: 'Fora do horario' },
          { campo: 'mensagem_cancelamento', label: 'Apos cancelar' },
          { campo: 'mensagem_chamado_criado', label: 'Apos criar chamado (use {{numero}})' },
        ].map(({ campo, label }) => (
          <div key={campo} style={{ marginBottom: 14 }}>
            <label style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', display: 'block', marginBottom: 4 }}>
              {label}
            </label>
            <textarea
              className="form-control"
              rows={3}
              value={config[campo] || ''}
              onChange={(e) => setCampo(campo, e.target.value)}
              placeholder={PLACEHOLDERS[campo]}
            />
          </div>
        ))}
      </section>

      {/* Som */}
      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <h4 style={{ color: 'var(--portal-text)', marginBottom: 12 }}>
          <i className="bi bi-volume-up me-2" /> Som de nova mensagem
        </h4>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 16 }}>
          Configuracao usada na tela de conversas quando chegam novas mensagens.
        </p>

        <div className="form-check form-switch mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="som-nova-mensagem-ativo"
            checked={config.som_nova_mensagem_ativo !== false}
            onChange={(e) => setCampo('som_nova_mensagem_ativo', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="som-nova-mensagem-ativo">
            Tocar som ao receber mensagem
          </label>
        </div>

        <div
          className="row g-3"
          style={{
            margin: 0,
            opacity: config.som_nova_mensagem_ativo === false ? 0.55 : 1,
            pointerEvents: config.som_nova_mensagem_ativo === false ? 'none' : 'auto',
          }}
        >
          <div className="col-12 col-md-4" style={{ paddingLeft: 0 }}>
            <label style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', display: 'block', marginBottom: 4 }}>
              Tipo
            </label>
            <select
              className="form-select"
              value={config.som_nova_mensagem_tipo || 'suave'}
              onChange={(e) => setCampo('som_nova_mensagem_tipo', e.target.value)}
            >
              {SONS_NOVA_MENSAGEM.map((s) => (
                <option key={s.chave} value={s.chave}>{s.label}</option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-5">
            <label style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', display: 'block', marginBottom: 4 }}>
              Volume: {Number(config.som_nova_mensagem_volume ?? 60)}%
            </label>
            <input
              type="range"
              className="form-range"
              min={0}
              max={100}
              step={5}
              value={Number(config.som_nova_mensagem_volume ?? 60)}
              onChange={(e) => setCampo('som_nova_mensagem_volume', Number(e.target.value))}
            />
          </div>

          <div className="col-12 col-md-3" style={{ paddingRight: 0, display: 'flex', alignItems: 'flex-end' }}>
            <button
              type="button"
              className="btn btn-sm btn-outline-info w-100"
              onClick={() => playNotificationSound({
                ativo: config.som_nova_mensagem_ativo !== false,
                tipo: config.som_nova_mensagem_tipo || 'suave',
                volume: Number(config.som_nova_mensagem_volume ?? 60),
              })}
            >
              <i className="bi bi-play-fill me-1" /> Testar
            </button>
          </div>
        </div>
      </section>

      {/* SLA */}
      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <h4 style={{ color: 'var(--portal-text)', marginBottom: 12 }}>
          <i className="bi bi-stopwatch me-2" /> SLA por prioridade
        </h4>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 16 }}>
          TTFR = tempo maximo para a primeira resposta. TTR = tempo total para resolver.
          Os valores sao em minutos. Hoje sao apenas referencia visual; a Fase 5 vai
          calcular metricas e a Fase 6 vai gerar alertas.
        </p>

        <div className="table-shell">
          <table className="portal-table">
            <thead>
              <tr>
                <th>Prioridade</th>
                <th>TTFR (min)</th>
                <th>TTFR</th>
                <th>TTR (min)</th>
                <th>TTR</th>
              </tr>
            </thead>
            <tbody>
              {PRIORIDADES.map(({ chave, label }) => {
                const ttfrCampo = `sla_${chave}_ttfr_min`;
                const ttrCampo = `sla_${chave}_ttr_min`;
                return (
                  <tr key={chave}>
                    <td><strong>{label}</strong></td>
                    <td>
                      <input
                        type="number"
                        min={1}
                        className="form-control form-control-sm"
                        style={{ maxWidth: 120 }}
                        value={config[ttfrCampo] || 0}
                        onChange={(e) => setCampo(ttfrCampo, Number(e.target.value))}
                      />
                    </td>
                    <td className="cell-muted">{minutosParaTexto(config[ttfrCampo])}</td>
                    <td>
                      <input
                        type="number"
                        min={1}
                        className="form-control form-control-sm"
                        style={{ maxWidth: 120 }}
                        value={config[ttrCampo] || 0}
                        onChange={(e) => setCampo(ttrCampo, Number(e.target.value))}
                      />
                    </td>
                    <td className="cell-muted">{minutosParaTexto(config[ttrCampo])}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>

      {/* Categorias */}
      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
          <h4 style={{ color: 'var(--portal-text)', marginBottom: 0 }}>
            <i className="bi bi-tags me-2" /> Categorias do bot
          </h4>
          <button
            type="button"
            className="btn btn-sm"
            onClick={novaCategoria}
            style={{ background: '#2A8A9C', color: '#fff', border: 'none' }}
          >
            <i className="bi bi-plus-lg me-1" /> Nova categoria
          </button>
        </div>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 12 }}>
          Categorias exibidas no intake do WhatsApp. Inativas nao aparecem para
          novos chamados, mas chamados antigos continuam com a categoria gravada.
        </p>

        {categoriasErro ? (
          <div className="feedback-banner feedback-banner--error" style={{ fontSize: '0.85rem' }}>
            <i className="bi bi-exclamation-triangle me-2" />
            {categoriasErro}
          </div>
        ) : categorias.length === 0 ? (
          <div style={{ padding: 12, color: 'var(--portal-muted)', fontSize: '0.85rem' }}>
            Nenhuma categoria cadastrada.
          </div>
        ) : (
          <div className="table-shell">
            <table className="portal-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Chave</th>
                  <th style={{ width: 120 }}>Status</th>
                  <th style={{ width: 200, textAlign: 'right' }}>Acoes</th>
                </tr>
              </thead>
              <tbody>
                {categorias.map((c) => (
                  <tr key={c.id}>
                    <td>
                      <span style={{ opacity: c.ativo ? 1 : 0.55 }}>{c.nome}</span>
                      {c.descricao && (
                        <div style={{ fontSize: '0.76rem', color: 'var(--portal-muted)' }}>
                          {c.descricao}
                        </div>
                      )}
                    </td>
                    <td className="cell-muted">{c.chave}</td>
                    <td>
                      <span className="permissao-chip" style={{
                        background: c.ativo ? 'rgba(76,181,83,0.15)' : 'rgba(94,122,130,0.15)',
                        color: c.ativo ? '#4CB553' : '#5E7A82',
                        border: `1px solid ${c.ativo ? '#4CB55355' : '#5E7A8255'}`,
                      }}>
                        {c.ativo ? 'ativo' : 'inativo'}
                      </span>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <div style={{ display: 'inline-flex', gap: 6 }}>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => renomearCategoria(c)}
                          title="Editar"
                        >
                          <i className="bi bi-pencil" />
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-info"
                          onClick={() => toggleAtivoCategoria(c)}
                          title={c.ativo ? 'Desativar' : 'Ativar'}
                        >
                          <i className={`bi ${c.ativo ? 'bi-toggle-on' : 'bi-toggle-off'}`} />
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removerCategoria(c)}
                          title="Remover"
                        >
                          <i className="bi bi-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>

      {/* Filiais — somente leitura, fonte: view dbo.FILIAIS em BDCENTRAO */}
      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <h4 style={{ color: 'var(--portal-text)', marginBottom: 8 }}>
          <i className="bi bi-buildings me-2" /> Filiais do bot
        </h4>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 12 }}>
          Carregadas automaticamente da view <code>dbo.FILIAIS</code> em BDCENTRAO.
          Nao e possivel inserir ou editar filiais por aqui — qualquer alteracao deve ser feita diretamente na view/ERP.
          O bot exibe o codigo da filial ao usuario no intake.
        </p>

        {filiaisErro ? (
          <div className="feedback-banner feedback-banner--error" style={{ fontSize: '0.85rem' }}>
            <i className="bi bi-exclamation-triangle me-2" />
            {filiaisErro}
          </div>
        ) : filiais.length === 0 ? (
          <div style={{ padding: 12, color: 'var(--portal-muted)', fontSize: '0.85rem' }}>
            Nenhuma filial encontrada na view dbo.FILIAIS.
          </div>
        ) : (
          <div className="table-shell">
            <table className="portal-table">
              <thead>
                <tr>
                  <th style={{ width: 90 }}>Codigo</th>
                  <th>Nome</th>
                </tr>
              </thead>
              <tbody>
                {filiais.map((f) => (
                  <tr key={f.codigo || f.nome}>
                    <td className="cell-muted">
                      <span style={{ fontFamily: 'monospace' }}>{f.codigo || '—'}</span>
                    </td>
                    <td>{f.nome}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>

      {/* Setores */}
      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
          <h4 style={{ color: 'var(--portal-text)', marginBottom: 0 }}>
            <i className="bi bi-diagram-3 me-2" /> Setores do bot
          </h4>
          <button
            type="button"
            className="btn btn-sm"
            onClick={novoSetor}
            style={{ background: '#2A8A9C', color: '#fff', border: 'none' }}
          >
            <i className="bi bi-plus-lg me-1" /> Novo setor
          </button>
        </div>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 12 }}>
          Setores exibidos no intake do bot. Sem setores cadastrados, o bot
          aceita texto livre (compatibilidade). Inativos nao aparecem para
          novos chamados.
        </p>

        {setoresErro ? (
          <div className="feedback-banner feedback-banner--error" style={{ fontSize: '0.85rem' }}>
            <i className="bi bi-exclamation-triangle me-2" />
            {setoresErro}
          </div>
        ) : setores.length === 0 ? (
          <div style={{ padding: 12, color: 'var(--portal-muted)', fontSize: '0.85rem' }}>
            Nenhum setor cadastrado. Bot vai pedir texto livre.
          </div>
        ) : (
          <div className="table-shell">
            <table className="portal-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th style={{ width: 120 }}>Status</th>
                  <th style={{ width: 200, textAlign: 'right' }}>Acoes</th>
                </tr>
              </thead>
              <tbody>
                {setores.map((s) => (
                  <tr key={s.id}>
                    <td>
                      <span style={{ opacity: s.ativo ? 1 : 0.55 }}>{s.nome}</span>
                    </td>
                    <td>
                      <span className="permissao-chip" style={{
                        background: s.ativo ? 'rgba(76,181,83,0.15)' : 'rgba(94,122,130,0.15)',
                        color: s.ativo ? '#4CB553' : '#5E7A82',
                        border: `1px solid ${s.ativo ? '#4CB55355' : '#5E7A8255'}`,
                      }}>
                        {s.ativo ? 'ativo' : 'inativo'}
                      </span>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <div style={{ display: 'inline-flex', gap: 6 }}>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => renomearSetor(s)}
                          title="Editar"
                        >
                          <i className="bi bi-pencil" />
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-info"
                          onClick={() => toggleAtivoSetor(s)}
                          title={s.ativo ? 'Desativar' : 'Ativar'}
                        >
                          <i className={`bi ${s.ativo ? 'bi-toggle-on' : 'bi-toggle-off'}`} />
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removerSetor(s)}
                          title="Remover"
                        >
                          <i className="bi bi-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>

      {/* Modos de encerramento */}
      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
          <h4 style={{ color: 'var(--portal-text)', marginBottom: 0 }}>
            <i className="bi bi-flag me-2" /> Modos de encerramento
          </h4>
          <button
            type="button"
            className="btn btn-sm"
            onClick={abrirNovoModo}
            style={{ background: '#2A8A9C', color: '#fff', border: 'none' }}
          >
            <i className="bi bi-plus-lg me-1" /> Novo modo
          </button>
        </div>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 12 }}>
          O atendente escolhe um modo ao encerrar a conversa. A mensagem configurada
          e enviada automaticamente ao cliente. Use <code>{'{{protocolo}}'}</code> (ou
          <code>{'{{numero_chamado}}'}</code>) para incluir o numero do chamado registrado.
        </p>

        {motivosErro ? (
          <div className="feedback-banner feedback-banner--error" style={{ fontSize: '0.85rem' }}>
            <i className="bi bi-exclamation-triangle me-2" />
            {motivosErro}
          </div>
        ) : motivos.length === 0 ? (
          <div style={{ padding: 12, color: 'var(--portal-muted)', fontSize: '0.85rem' }}>
            Nenhum modo cadastrado.
          </div>
        ) : (
          <div className="table-shell">
            <table className="portal-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Mensagem ao cliente</th>
                  <th style={{ width: 110 }}>Status</th>
                  <th style={{ width: 160, textAlign: 'right' }}>Acoes</th>
                </tr>
              </thead>
              <tbody>
                {motivos.map((m) => (
                  <tr key={m.id}>
                    <td style={{ whiteSpace: 'nowrap' }}>
                      <span style={{ opacity: m.ativo ? 1 : 0.55 }}>{m.descricao}</span>
                    </td>
                    <td>
                      {m.mensagem_cliente ? (
                        <span style={{ fontSize: '0.82rem', color: 'var(--portal-muted)', opacity: m.ativo ? 1 : 0.55 }}>
                          {String(m.mensagem_cliente).slice(0, 80)}{m.mensagem_cliente.length > 80 ? '…' : ''}
                        </span>
                      ) : (
                        <span style={{ fontSize: '0.78rem', color: 'var(--portal-muted)', opacity: 0.5, fontStyle: 'italic' }}>
                          (mensagem padrao)
                        </span>
                      )}
                    </td>
                    <td>
                      <span className="permissao-chip" style={{
                        background: m.ativo ? 'rgba(76,181,83,0.15)' : 'rgba(94,122,130,0.15)',
                        color: m.ativo ? '#4CB553' : '#5E7A82',
                        border: `1px solid ${m.ativo ? '#4CB55355' : '#5E7A8255'}`,
                      }}>
                        {m.ativo ? 'ativo' : 'inativo'}
                      </span>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <div style={{ display: 'inline-flex', gap: 6 }}>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => abrirEditarModo(m)}
                          title="Editar"
                        >
                          <i className="bi bi-pencil" />
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-info"
                          onClick={() => toggleAtivoMotivo(m)}
                          title={m.ativo ? 'Desativar' : 'Ativar'}
                        >
                          <i className={`bi ${m.ativo ? 'bi-toggle-on' : 'bi-toggle-off'}`} />
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removerMotivo(m)}
                          title="Remover"
                        >
                          <i className="bi bi-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>

      {/* Modal criar/editar modo de encerramento */}
      {modoModal.aberto && (
        <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.7)', zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 520 }}>
            <div className="modal-content" style={{ background: 'var(--portal-surface)', color: 'var(--portal-text)' }}>
              <div className="modal-header" style={{ borderColor: 'var(--portal-border)' }}>
                <h5 className="modal-title">
                  <i className="bi bi-flag me-2" />
                  {modoModal.editando ? 'Editar modo de encerramento' : 'Novo modo de encerramento'}
                </h5>
                <button className="btn-close btn-close-white" onClick={fecharModoModal} disabled={modoSalvando} />
              </div>
              <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div>
                  <label style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', display: 'block', marginBottom: 6 }}>
                    Nome <span style={{ color: '#dc3545' }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={modoNome}
                    onChange={(e) => setModoNome(e.target.value)}
                    placeholder="Ex: Resolvido, Encaminhado, Sem solucao"
                    autoFocus
                  />
                </div>
                <div>
                  <label style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', display: 'block', marginBottom: 6 }}>
                    Mensagem ao cliente (enviada via WhatsApp ao encerrar)
                  </label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={modoMensagem}
                    onChange={(e) => setModoMensagem(e.target.value)}
                    placeholder={'Seu atendimento foi encerrado.\n\nSe precisar de mais alguma coisa, e so mandar uma mensagem.'}
                  />
                  <div style={{ fontSize: '0.75rem', color: 'var(--portal-muted)', marginTop: 6 }}>
                    Deixe em branco para usar a mensagem padrao generica.
                    Use <code>{'{{protocolo}}'}</code> (ou <code>{'{{numero_chamado}}'}</code>)
                    para incluir o numero do chamado registrado.
                  </div>
                </div>
              </div>
              <div className="modal-footer" style={{ borderColor: 'var(--portal-border)' }}>
                <button className="btn btn-outline-secondary" onClick={fecharModoModal} disabled={modoSalvando}>
                  Cancelar
                </button>
                <button
                  className="btn"
                  onClick={salvarModo}
                  disabled={modoSalvando || modoNome.trim().length < 3}
                  style={{ background: 'linear-gradient(135deg, #2A8A9C 0%, #1E6370 100%)', color: '#fff', fontWeight: 600, border: 'none', padding: '6px 18px' }}
                >
                  {modoSalvando ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <section className="content-card" style={{ padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
          <h4 style={{ color: 'var(--portal-text)', marginBottom: 0 }}>
            <i className="bi bi-lightning-charge me-2" /> Respostas rapidas
          </h4>
          <button type="button" className="btn btn-sm" onClick={abrirNovaRR}
            style={{ background: '#2A8A9C', color: '#fff', border: 'none' }}>
            <i className="bi bi-plus-lg me-1" /> Nova resposta
          </button>
        </div>
        <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)', marginBottom: 12 }}>
          Frases prontas pro compositor. No chat, digitar <code>/atalho</code> abre a sugestao;
          Tab autocompleta a 1a. O botao <i className="bi bi-lightning-charge-fill" /> lista todas.
        </p>
        {respostasErro ? (
          <div className="feedback-banner feedback-banner--error" style={{ fontSize: '0.85rem' }}>
            <i className="bi bi-exclamation-triangle me-2" />{respostasErro}
          </div>
        ) : respostas.length === 0 ? (
          <div style={{ padding: 12, color: 'var(--portal-muted)', fontSize: '0.85rem' }}>
            Nenhuma resposta rapida cadastrada.
          </div>
        ) : (
          <div className="table-shell">
            <table className="portal-table">
              <thead>
                <tr>
                  <th style={{ width: 160 }}>Atalho</th>
                  <th>Texto</th>
                  <th style={{ width: 100 }}>Status</th>
                  <th style={{ width: 140, textAlign: 'right' }}>Acoes</th>
                </tr>
              </thead>
              <tbody>
                {respostas.map((r) => (
                  <tr key={r.id}>
                    <td><code style={{ opacity: r.ativo ? 1 : 0.55 }}>/{r.atalho}</code></td>
                    <td style={{ opacity: r.ativo ? 1 : 0.55 }}>
                      <span style={{ fontSize: '0.85rem' }}>
                        {String(r.texto).slice(0, 120)}{r.texto.length > 120 ? '…' : ''}
                      </span>
                    </td>
                    <td>
                      <span className="permissao-chip" style={{
                        background: r.ativo ? 'rgba(76,181,83,0.15)' : 'rgba(94,122,130,0.15)',
                        color: r.ativo ? '#4CB553' : '#5E7A82',
                        border: `1px solid ${r.ativo ? '#4CB55355' : '#5E7A8255'}`,
                      }}>{r.ativo ? 'ativa' : 'inativa'}</span>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <div style={{ display: 'inline-flex', gap: 6 }}>
                        <button type="button" className="btn btn-sm btn-outline-secondary"
                          onClick={() => abrirEditarRR(r)} title="Editar">
                          <i className="bi bi-pencil" />
                        </button>
                        <button type="button" className="btn btn-sm btn-outline-info"
                          onClick={() => toggleRR(r)} title={r.ativo ? 'Desativar' : 'Ativar'}>
                          <i className={`bi ${r.ativo ? 'bi-pause-fill' : 'bi-play-fill'}`} />
                        </button>
                        <button type="button" className="btn btn-sm btn-outline-danger"
                          onClick={() => removerRR(r)} title="Remover">
                          <i className="bi bi-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>

      {rrModal.aberto && (
        <div
          onClick={(e) => { if (e.target === e.currentTarget) fecharRR(); }}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 4000,
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
        >
          <div className="content-card" style={{ width: '100%', maxWidth: 520, padding: 20 }}>
            <h5 style={{ marginBottom: 12 }}>
              <i className="bi bi-lightning-charge me-2" />
              {rrModal.editando ? 'Editar resposta rapida' : 'Nova resposta rapida'}
            </h5>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 600 }}>Atalho</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }}>
                <span style={{ color: 'var(--portal-muted)', fontWeight: 700 }}>/</span>
                <input type="text" value={rrAtalho}
                  onChange={(e) => setRrAtalho(e.target.value.toLowerCase())}
                  placeholder="abertura" maxLength={40}
                  style={{ flex: 1, padding: '6px 10px', borderRadius: 6,
                    border: '1px solid var(--portal-border)',
                    background: 'var(--portal-surface)', color: 'var(--portal-text)' }}
                />
              </div>
              <small style={{ color: 'var(--portal-muted)' }}>
                2 a 40 caracteres. Letras minusculas, numeros, _ . -
              </small>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 600 }}>Texto</label>
              <textarea value={rrTexto} onChange={(e) => setRrTexto(e.target.value)}
                rows={5} maxLength={2000}
                placeholder="Ola! Estou verificando aqui e volto ja."
                style={{ width: '100%', marginTop: 4, padding: '6px 10px', borderRadius: 6,
                  border: '1px solid var(--portal-border)',
                  background: 'var(--portal-surface)', color: 'var(--portal-text)',
                  resize: 'vertical' }}
              />
              <small style={{ color: 'var(--portal-muted)' }}>{rrTexto.length} / 2000</small>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={fecharRR}>
                Cancelar
              </button>
              <button type="button" className="btn" onClick={salvarRR}
                disabled={rrSalvando || rrAtalho.trim().length < 2 || rrTexto.trim().length < 1}
                style={{ background: 'linear-gradient(135deg, #2A8A9C 0%, #1E6370 100%)',
                  color: '#fff', fontWeight: 600, border: 'none', padding: '6px 18px' }}>
                {rrSalvando ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <button
          type="button"
          className="btn"
          onClick={salvar}
          disabled={salvando}
          style={{
            background: 'linear-gradient(135deg, #2A8A9C 0%, #1E6370 100%)',
            color: '#fff', fontWeight: 600, border: 'none', padding: '8px 22px',
          }}
        >
          {salvando ? 'Salvando...' : <><i className="bi bi-check2-circle me-2" />Salvar configuracao</>}
        </button>
      </div>
    </div>
  );
}
